import Vue from 'vue';
import App from './App';
import VueRouter from 'vue-router';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import Scrollspy from 'vue2-scrollspy';
import VModal from 'vue-js-modal';
//import * as VueGoogleMaps from 'vue2-google-maps';

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyBD1q7OxoNbJCBcoxG3ALBGG52VSYGKykQ',
//     libraries: 'places', // This is required if you use the Autocomplete plugin
//     // OR: libraries: 'places,drawing'
//     // OR: libraries: 'places,drawing,visualization'
//     // (as you require)

//     //// If you want to set the version, you can do so:
//     // v: '3.26',
//   },

//   //// If you intend to programmatically custom event listener code
//   //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
//   //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
//   //// you might need to turn this on.
//   // autobindAllEvents: false,

//   //// If you want to manually install components, e.g.
//   //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
//   //// Vue.component('GmapMarker', GmapMarker)
//   //// then set installComponents to 'false'.
//   //// If you want to automatically install all the components this property must be set to 'true':
//   installComponents: true
// });
 
Vue.use(VModal, { dialog: true });

//import VueScrollTo from 'vue-scrollto';

import Home from './components/Home';
import NotFound from './components/NotFound';

Vue.use(VueRouter);
export const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production'
    ? '/forte/'
    : '/',
  routes: [
    { 
        path: '/', 
        component: Home
    
    },
      
      { path: '*', component: NotFound }
  ]
});

Vue.use(Scrollspy);

// Vue.use(VueScrollTo, {
//   offset: -200
// });

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');

AOS.init({
  //disable: 'mobile',
});

